import React from 'react';
import { FormattedNumber } from 'react-intl';

import { Card, Flex, Tooltip, Typography } from 'antd';
import { Icon } from '@eduzz/ui-antd-theme';

import MyIcon from 'components/Icon';
import Truncate from 'components/Truncate';
import { URL_SELECT } from 'settings';

interface IProps {
  data: any;
}

const ProductCard: React.FC<IProps> = ({ data }) => {
  return (
    <a onClick={() => window.open(`${URL_SELECT}/product/details/${data.id}`)}>
      <Card hoverable className='h-full cursor-pointer text-center'>
        <div className='mx-auto my-4 block size-37.5 max-w-full overflow-hidden [&>img]:w-full [&>img]:rounded-sm'>
          <img src={data.image ? data.image : ''} alt='Product' />
        </div>
        <Typography.Text className='block px-2 pt-0 pb-2 text-sm leading-snug [&>div]:max-h-9 [&>div]:min-h-9'>
          <Truncate title={data.title} final={' '} count={34}>
            {data.title}
          </Truncate>
        </Typography.Text>
        <Typography.Text type='secondary' className='block px-8 pt-0 pb-2 text-xs leading-snug'>
          <Truncate title={data.producer_name} final={' '} count={20}>
            {data.producer_name}
          </Truncate>
        </Typography.Text>
        <Flex align='center' justify='space-between' className='p-4 [&>img]:w-6'>
          <Tooltip placement='top' title={data.infinity_funnel ? 'Funil Infinito Ativo' : 'Funil Infinito Inativo'}>
            <img src={data.infinity_funnel ? '/img/icon_funil_ativo.png' : '/img/icon_funil.png'} alt='Icon' />
          </Tooltip>
          <Tooltip
            placement='top'
            title={data.sales_recovery ? 'Recuperação de Vendas Ativa' : 'Recuperação de Vendas Inativa'}
          >
            <img
              src={data.sales_recovery ? '/img/icon_recuperacao_ativo.png' : '/img/icon_recuperacao.png'}
              alt='Icon'
            />
          </Tooltip>
          {(data.has_subscription || data.charge_type === 'A') && (
            <Tooltip title='Possui cobrança recorrente' placement='top'>
              <div>
                <MyIcon className='flex w-6 items-center' name='icon-assinaturas' />
              </div>
            </Tooltip>
          )}
          {data.recruit === true && (
            <Tooltip title='Possui comissão de recrutamento' placement='top'>
              <img src='/img/icon_recruit.png' alt='Recruit' />
            </Tooltip>
          )}
          <Tooltip placement='top' title='RPC Produtor'>
            <Typography.Text className='text-right text-sm'>
              <Typography.Text className='block text-xs'>RPC P</Typography.Text>
              {data.rpc_producer !== 0 ? <FormattedNumber maximumFractionDigits={2} value={data.rpc_producer} /> : '-'}
            </Typography.Text>
          </Tooltip>
          <Tooltip placement='top' title='RPC Afiliados'>
            <Typography.Text className='text-right text-sm'>
              <Typography.Text className='block text-xs'>RPC A</Typography.Text>
              {data.rpc_affiliate !== 0 ? (
                <FormattedNumber maximumFractionDigits={2} value={data.rpc_affiliate} />
              ) : (
                '-'
              )}
            </Typography.Text>
          </Tooltip>
        </Flex>
        <Flex align='center' justify='space-between' className='px-4 py-2'>
          <div>
            <Typography.Text strong className='block text-left text-xs'>
              Comissão:
            </Typography.Text>
            <Typography.Text className='block text-left text-[[0.8125rem]'>
              {data.showcase_subscription_commission &&
                !data.showcase_subscription_commission.includes('R$ 0,00') &&
                `${data.showcase_subscription_commission} rec.`}
            </Typography.Text>
            <Typography.Text className='block text-left text-[[0.8125rem]'>
              {data.showcase_commission &&
                !data.showcase_commission.includes('R$ 0,00') &&
                `${data.showcase_commission}`}
            </Typography.Text>
          </div>
          <Typography.Text className='flex items-center text-right text-sm'>
            {data.rating !== '0' ? data.rating : '-'}
            <span className='text-secondary-600 ml-1'>
              <Icon.Star fill='currentColor'  />
            </span>
          </Typography.Text>
        </Flex>
      </Card>
    </a>
  );
};

export default ProductCard;
